<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Contents</p>
<p class="toc"><a href="#/Acknowledgments">Acknowledgments</a></p>
<p class="toc"><a href="#/Chapter1#C1">The Eat Fit Zero Proof Story</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">Crafting the Zero Proof Cocktail</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">The Art + Science of Sweeteners + Simple Syrups</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">DIY Infusions | Bitters, Shrubs + Simple Syrups</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Glassware</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Garnishes + Embellishments</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Zero Proof Picks</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">The Drinks</span></p>
<p class="toc1"><span href="#/Chapter8#C8" title="Link target outside of Sample">New Orleans + Classics</span></p>
<p class="toc1"><span href="#/Chapter9#C9" title="Link target outside of Sample">Herbal + Florals</span></p>
<p class="toc1"><span href="#/Chapter10#C10" title="Link target outside of Sample">Sweet + Spicy</span></p>
<p class="toc1"><span href="#/Chapter11#C11" title="Link target outside of Sample">Highballs + Collinses</span></p>
<p class="toc1"><span href="#/Chapter12#C12" title="Link target outside of Sample">Fizzes, Flips + Smashes</span></p>
<p class="toc1"><span href="#/Chapter13#C13" title="Link target outside of Sample">Toddies + Teas</span></p>
<p class="toc1"><span href="#/Chapter14#C14" title="Link target outside of Sample">Tiki + Tropical</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?47812980